import request, { requestB2C } from "@/utils/request";
import qs from "qs";

import { ICountriesGetResponse } from "@/interfaces/_shared/common";

/**
 * Get countries list
 * Postman: `GET country list`
 */
export async function getCountryList(
  params: any
): Promise<ICountriesGetResponse> {
  const response = await request({
    url: `/common/countrylist?${qs.stringify(params, { encode: false })}`,
    method: "get",
  });

  return response.data;
}

// Return the user's country code
export async function userCountry() {
  const response = await requestB2C({
    method: "get",
    url: "/common/country-by-ip",
  });

  return response.data.countryCode;
}

/**
 * Get languages list
 */
export async function getLanguageList(): Promise<any> {
  const response = await request({
    url: `/common/language`,
    method: "get",
  });
  return response.data.data;
}
